import { Typography } from "@mui/material";
import { SearchableDropdown } from "../../components/SearchableDropdown";
import { QuestionChoice } from "../template-builder/types";
import { checkAndReturnValidJSON } from "../../utilities/UIHelper";

type MultipleDropdownCustomFieldProps = {
  value: string[] | null;
  onChange: (value: string[] | null) => void;
  choices?: string[] | QuestionChoice[];
  disabled?: boolean;
};

export const MultipleDropdownCustomField = (props: MultipleDropdownCustomFieldProps) => {
  const { value, onChange, choices: _choices, disabled } = props;
  const choices: string[] =
    !_choices || _choices.length === 0
      ? []
      : typeof _choices[0] === "string"
      ? (_choices as string[])
      : (_choices as QuestionChoice[]).map((c) => c.label);

  const processedValue = () => {
    if (value === null || value === undefined) {
      return [];
    }

    if (typeof value === "string") {
      try {
        const parsedValue = checkAndReturnValidJSON(value, []);
        return Array.isArray(parsedValue) ? parsedValue : [];
      } catch (e) {
        return [];
      }
    }

    return Array.isArray(value) ? value : [];
  };

  return choices && choices.length > 0 ? (
    <SearchableDropdown<string>
      value={processedValue()}
      multiple={true}
      onChange={(newValue) => newValue !== null && onChange(newValue)}
      getOptions={(search: string) =>
        choices?.filter((option) => option?.includes(search.toLowerCase())) ?? []
      }
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(a, b) => a === b}
      disabled={disabled}
    />
  ) : (
    <Typography variant="body2">Missing choices</Typography>
  );
};
